import {
	CircularProgress,
	Container,
	Grid,
	useMediaQuery
} from "@mui/material";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import CountdownV2 from "components/CountdownV2";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import {
	useEnvContext,
	useGoogleAnalyticsContext,
	useWebStoreContext
} from "contexts";
import { IShopReward, IShopRewardItem } from "contexts/WebStoreProvider/types";
import { FeaturesFlags } from "helpers";
import { useAppDispatch, useAppSelector } from "hooks";
import { Config, PurchaseOfferSingleItem, WsDialogs } from "interfaces";
import { DripOfferResponse, Node, Tracker } from "interfaces/drip-offer";
import { FeatureType } from "interfaces/feature-tracker";
import {
	getAvailablePrizes,
	getFilteredTracker,
	getNodeItemData,
	handleTicketVariant,
	handleTitleImageVariant
} from "pages/DripOffer/hooks";
import {
	DisplayFirstNode,
	DisplayNode,
	Offer,
	SaleInfo
} from "pages/DripOffer/lib";
import { InfoButton } from "pages/DripOffer/styles";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	featureTrackerAPI,
	offersApi,
	useClaimDripOfferRewardMutation,
	useGetFeatureTrackersQuery
} from "redux/apis";
import {
	onClosePopUp,
	onOpenPopUp,
	selectDipState,
	setPricePoint,
	setTriggerOnCache
} from "redux/slices";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import { getVariantImage } from "helpers/getVariantImage";
import { InfoIcon } from "utils/svgIcons";
import {
	Background,
	Button,
	ContainerScaled,
	DripOfferContainer,
	Title,
	timerStyle
} from "./styles";
import { getCount, getDisplay, getTimeLeft } from "utils/time";

export const DripOffer = () => {
	const isSmall = useMediaQuery("(max-width: 754px)");
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const scale = useCalculateScale(
		isPortrait ? 400 : 854,
		isPortrait ? 800 : 457
	);

	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const {
		authToken,
		handleErrorResponse,
		nowTime,
		postUserMetadata,
		store,
		suppressOrderConfirmation,
		userTracker,
		wsStoreBuy
	} = useWebStoreContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const [filteredTracker, setfilteredTracker] = useState<Tracker>();
	const { data: dipsData } = useAppSelector(selectDipState);
	const [infoIndex, setInfoIndex] = useState<number>(-1);
	const { isFeatureFlagEnabled } = useEnvContext();
	const { openDialog } = useDialogModalRedux();

	const [ClaimDripOfferReward, { isLoading: IsClaimLoading }] =
		useClaimDripOfferRewardMutation();

	const {
		data,
		refetch,
		isSuccess,
		isFetching,
		isError
	}: {
		data?: DripOfferResponse;
		refetch: () => void;
		isSuccess: boolean;
		isFetching: boolean;
		isError: boolean;
	} = useGetFeatureTrackersQuery(
		{
			FeatureType: FeatureType.DRIP_OFFER,
			isAuthenticated: !!userTracker
		},
		{
			skip:
				!isFeatureFlagEnabled(FeaturesFlags.DRIP_OFFER) ||
				!userTracker ||
				location.pathname === "/special-offers",
			refetchOnFocus: true
		}
	);

	const { data: purchaseOffers } = offersApi.endpoints.getOffers.useQueryState({
		offerType: "singleItem",
		isAuthenticated: !!authToken?.value
	});

	const [firstOffer, setFirstOffer] = useState<{
		offer: PurchaseOfferSingleItem;
		items: IShopRewardItem[];
	}>();
	const [availableNode, setAvailableNode] = useState<Node>();
	const [xsollaOpened, setXsollaOpened] = useState<{
		opened: boolean;
		eventId: string;
	}>({ opened: false, eventId: "" });

	const { trackers } = data || {};

	const onClose = () => {
		dispatch(onClosePopUp());
		if (xsollaOpened.opened && !filteredTracker?.offerPurchaseDate) {
			if (
				dipsData?.dips?.find(
					(obj) => obj.dip.triggerType === "purchaseCancelled-multi-reward"
				)
			) {
				firstOffer?.offer.price &&
					dispatch(setPricePoint(firstOffer.offer.price));
				dispatch(setTriggerOnCache("purchaseCancelled-multi-reward"));
			} else {
				dispatch(setTriggerOnCache("purchaseCancelled"));
			}
		}
	};

	const onOpenInfoPopup = (index: number) => {
		navigate("/special-offers");
		dispatch(onOpenPopUp(`drip-offer-info::${index}`));
	};

	const handleEnd = () => {
		setTimeout(() => {
			onClose();
		}, 1000);
	};

	const invalidateFeatureTracker = () => {
		dispatch(
			featureTrackerAPI.util.invalidateTags([
				{
					type: "featureTrackerTag",
					id: FeatureType.DRIP_OFFER
				}
			])
		);
	};

	const onClickBuy = async (
		tracker: Tracker,
		offer?: PurchaseOfferSingleItem,
		node?: Node
	) => {
		if (!authToken?.value) {
			return;
		}

		const { offerPurchaseDate, nodes, claimEndDate, eventId, offerEndDate } =
			tracker;

		if (offerPurchaseDate && node) {
			await ClaimDripOfferReward({
				eventId: node.eventId,
				nodeIndex: node.nodeIndex
			})
				.unwrap()
				.then(() => {
					if (getAvailablePrizes(nodes) === 1) {
						dispatch(onOpenPopUp("drip-offer-end"));
					} else {
						dispatch(onOpenPopUp("drip-offer-reward"));
					}
					//navigate("/special-offers");
					//refetch();
					/* navigate("/shop");
					dispatch(onScrollToShopSection("Featured Deals")); */
					setAvailableNode(undefined);
					if (store) {
						const timeRemaining = getCount(nowTime, claimEndDate);
						const timeToDisplay = getDisplay(timeRemaining);
						const timeLeft = getTimeLeft(nowTime, offerEndDate, "seconds");
						const rewardType: IShopRewardItem[] | null = getNodeItemData(
							store,
							node
						);
						reportEvent("drip_offer", {
							source: "claim_free_daily_reward",
							reward_id: node.rewardId,
							reward_type: `${rewardType?.[0].id}_${rewardType?.[0].value}`,
							location: "special_offer_section",
							time_to_claim: timeToDisplay
						});
						reportPlaygamiEvent("tp.web_frontend", {
							event_name: "drip_offer",
							event_type: "claim_free_daily_reward",
							action: "show_pop_up",
							source: "drip_offer",
							reward_id: node.rewardId,
							reward_type: `${rewardType?.[0].id}_${rewardType?.[0].value}`,
							section_name: location.pathname.replace("/", ""),
							time_left: timeLeft,
							type: "drip_offer_collect_popup"
						});
					}
				})
				.catch(() => {
					const response = {
						data: {
							errorCode: "The prize has already been claimed!",
							errorMessage: ""
						}
					};
					handleErrorResponse({ response: response });
					invalidateFeatureTracker();
				});
		} else if (!offerPurchaseDate && offer) {
			const { id, price, rewardId } = offer;

			wsStoreBuy({ offerId: id, drip_offer_event_id: eventId }).then(
				(invoice) => {
					if (invoice) {
						const timestampMs = new Date().getTime();
						openDialog(WsDialogs.XSOLLA_PURCHASE, {
							xsollaToken: invoice.xsollaToken,
							xsollaHost: invoice.xsollaHost,
							invoice,
							suppressOrderConfirmation,
							source: "drip-offer-popup",
							pricePoint: price,
							postUserMetadata,
							onPurchaseStarted: (data) => {
								const minutesLeft = getTimeLeft(nowTime, offerEndDate);
								reportEvent("purchase_started", {
									section_name: "special_offer_popup",
									offer_id: id,
									price_in_cents: price * 100,
									reward_id: rewardId,
									invoice_id: invoice?.id,
									paystation_id: data?.payStation
								});
								reportPlaygamiEvent("tp.web_ga.purchase_flow", {
									event_name: "purchase_started",
									event_type: "web_paystation_purchase",
									action: "purchase_started",
									section_name: "special_offer_popup",
									purchase_flow_id: data?.payStation,
									session_engaged: authToken?.value ? "1" : "0",
									price_in_cents: Math.round(invoice?.price * 100),
									page_location: window.location.href,
									engagement_time_msec: (
										Number(data?.data?.milliseconds) - timestampMs
									).toString(),
									reward_id: invoice?.rewardId,
									offer_id: invoice?.offerId,
									ignore_referrer:
										process.env.REACT_APP_WITH_DEBUG === "true"
											? "true"
											: "false",
									minutes_left: minutesLeft,
									page_title: location.pathname.replace("/", ""),
									page_referrer: invoice?.invoiceMetadata?.referer,
									invoice_id: invoice?.id
								});
							},
							onPurchaseSuccess: (data) => {
								reportEvent("purchase_success", {
									invoice_id: invoice?.id
								});
								reportPlaygamiEvent("tp.web_ga.purchase_flow", {
									event_name: "purchase_success",
									event_type: "web_paystation_purchase",
									action: "purchase_success",
									section_name: "special_offer_popup",
									purchase_flow_id: data?.version,
									session_engaged: authToken?.value ? "1" : "0",
									price_in_cents: Math.round(invoice?.price * 100),
									page_location: window.location.href,
									engagement_time_msec: (
										Number(data?.milliseconds) - timestampMs
									).toString(),
									reward_id: invoice?.rewardId,
									offer_id: invoice?.offerId,
									ignore_referrer:
										process.env.REACT_APP_WITH_DEBUG === "true"
											? "true"
											: "false",
									page_title: location.pathname.replace("/", ""),
									page_referrer: invoice?.invoiceMetadata?.referer,
									invoice_id: invoice?.id,
									transaction_id: data?.purchase_invoice_id?.toString()
								});
								refetch();
								dispatch(onOpenPopUp("drip-offer-reward"));
								//navigate("/special-offers");
							},
							cbClose: () => {
								setXsollaOpened({ opened: true, eventId: tracker.eventId });
								reportEvent("dialog_x_closed", {
									source: "xsolla_dialog",
									page_location: location.pathname
								});
							}
						});
					}
				}
			);
		}
	};

	useEffect(() => {
		if (trackers && trackers.length > 0) {
			const filteredTrackers = getFilteredTracker(trackers);
			if (filteredTrackers) {
				setfilteredTracker(filteredTrackers);
				setInfoIndex(
					trackers.findIndex(
						(t: Tracker) => t.eventId === filteredTrackers.eventId
					)
				);
			}
		}
	}, [trackers]);

	useEffect(() => {
		if ((isSuccess && !data?.trackers) || isError) {
			dispatch(onClosePopUp());
		}
	}, [data, isSuccess, isError]);

	useEffect(() => {
		if (isFetching) {
			setAvailableNode(undefined);
		}
	}, [isFetching]);

	useEffect(() => {
		if (filteredTracker && purchaseOffers) {
			const offer: PurchaseOfferSingleItem = purchaseOffers.offers.find(
				(offer: Config) => offer.id === filteredTracker.offerId
			);
			if (offer) {
				if (store) {
					const reward = store.rewards[offer.rewardId];
					if (!reward) {
						console.error("reward", reward);
						return;
					}
					const items: IShopRewardItem[] = Object.keys(reward.items).map(
						(key) => {
							const { imageUrl = "" } = {
								...store.rewardTypes.filter((t: IShopReward) => t.id === key)[0]
							};
							const rewardItem = reward.items;
							return {
								id: key,
								value: rewardItem[key as keyof typeof rewardItem],
								imageUrl
							};
						}
					);
					setFirstOffer({ offer: offer, items: items });
				}
			}
		}
	}, [purchaseOffers, filteredTracker, store?.rewards]);

	if (!filteredTracker) {
		return null;
	}

	const {
		claimEndDate,
		dateTimes,
		isFinished,
		nodes,
		backgroundPopupImageUrl,
		offerEndDate,
		offerPurchaseDate,
		offerTicketImageUrl,
		saleInfoImageUrl,
		titleImageUrl,
		claimDurationDays
	} = filteredTracker;

	if (Object.keys(filteredTracker).length > 0 && firstOffer) {
		return (
			<ContainerScaled scale={scale}>
				<CloseIconButton onClose={onClose} />
				<DripOfferContainer
					style={{ paintOrder: "stroke fill" }}
					largeTicket={getVariantImage(
						offerPurchaseDate ? saleInfoImageUrl : offerTicketImageUrl,
						"{drip_offer_variant}",
						"small"
					)}
				>
					<Background
						background={getVariantImage(
							backgroundPopupImageUrl,
							"{drip_offer_variant}",
							isPortrait && isSmall ? "small" : "large"
						)}
					>
						<Container sx={{ px: { xs: isSmall && isPortrait ? 5 : 2 } }}>
							<CountdownV2
								endTime={claimEndDate ?? offerEndDate}
								style={timerStyle}
								startTime={nowTime}
								text={claimEndDate ? "Time to claim: " : "Offer ends in: "}
								labelStyle={{ color: "#fff", marginLeft: 6 }}
								onEnd={() => {
									handleEnd();
								}}
							/>
							<Grid item xs={12} textAlign="center" py={1} position="relative">
								{isPortrait && isSmall && !offerPurchaseDate && (
									<InfoButton
										className="is-small"
										aria-label="open info popup"
										onClick={() => onOpenInfoPopup(infoIndex)}
									>
										<InfoIcon />
									</InfoButton>
								)}
								<Title
									src={handleTitleImageVariant(
										titleImageUrl,
										!!offerPurchaseDate
									)}
									alt="Tiki special offer"
								/>
								{offerPurchaseDate && !isPortrait && (
									<Grid
										item
										position="absolute"
										top={8}
										right={-6}
										zIndex={0}
										width={192}
										height={135}
									>
										<SaleInfo
											nodes={nodes}
											localTime={dateTimes.local}
											isPopup={true}
											nowTime={nowTime}
											endTime={claimEndDate}
											claimDurationDays={claimDurationDays}
										/>
									</Grid>
								)}
							</Grid>
							<Grid item>
								<Grid
									container
									direction="row"
									spacing={isSmall && isPortrait ? 0 : 1}
								>
									{!offerPurchaseDate && (
										<Grid item xs={isPortrait && isSmall ? 12 : 4}>
											<Offer firstOffer={firstOffer} isPopup={true} />
										</Grid>
									)}
									<Grid
										item
										xs={isPortrait && isSmall ? 12 : offerPurchaseDate ? 12 : 8}
									>
										<Grid item xs={12} position="relative">
											{(!isSmall || !isPortrait) && (
												<InfoButton
													className="is-popup"
													aria-label="open info popup"
													onClick={() => onOpenInfoPopup(infoIndex)}
												>
													<InfoIcon />
												</InfoButton>
											)}
											{!offerPurchaseDate && (
												<h3>Claim a new prize each day you login:</h3>
											)}
										</Grid>
										<Grid item mx="auto">
											<Grid
												container
												direction="row"
												spacing={1}
												mb={2}
												justifyContent="center"
											>
												{firstOffer && offerPurchaseDate && (
													<DisplayFirstNode
														items={firstOffer.items}
														background={handleTicketVariant(
															nodes[0].rewardBackgroundImageUrl,
															false
														)}
														isPopup={true}
													/>
												)}
												{nodes.map((node) => (
													<DisplayNode
														key={node.rewardId}
														node={node}
														onSetAvailableNode={(n: Node) =>
															!isFetching && setAvailableNode(n)
														}
														changeSize={!!offerPurchaseDate}
														availableNode={availableNode}
														isPopup={true}
													/>
												))}
												{offerPurchaseDate && isPortrait && isSmall && (
													<SaleInfo
														nodes={nodes}
														localTime={dateTimes.local}
														nowTime={nowTime}
														endTime={claimEndDate}
														isPopup={true}
														claimDurationDays={claimDurationDays}
													/>
												)}
											</Grid>
										</Grid>
									</Grid>
								</Grid>
								<Grid
									item
									xs={12}
									pb={2}
									display="flex"
									justifyContent="center"
								>
									{!isFinished && (
										<Button
											disabled={
												(offerPurchaseDate && !availableNode) ||
												(availableNode &&
													availableNode.state !== "available") ||
												IsClaimLoading
											}
											onClick={() =>
												onClickBuy(
													filteredTracker,
													firstOffer?.offer,
													availableNode
												)
											}
										>
											{isFetching ? (
												<CircularProgress
													size={24}
													style={{
														color: "#7b7b7b"
													}}
												/>
											) : (
												<>
													{offerPurchaseDate
														? availableNode &&
														  availableNode?.state === "available"
															? "COLLECT"
															: "Come Back Tomorrow"
														: `${firstOffer?.offer.price} USD`}
												</>
											)}
										</Button>
									)}
								</Grid>
							</Grid>
						</Container>
					</Background>
				</DripOfferContainer>
			</ContainerScaled>
		);
	} else {
		return null;
	}
};
